import * as _ from 'lodash';

export default function total(cart, payment) {
  let total = 0;
  let bookingFee = false;

  _.mapValues(cart.products, item => {

    item.map(quote => {

      if (parseFloat(quote.product.price) > 0) {
        let multiplier = quote.product.category === "airportparking" ? payment.vehicles.length : 1;

        if(quote.quantity) multiplier = payment.vehicles.length;

        // only allow the booking fee to be applied once
        if((quote.product.addon_id == 2 && bookingFee === false) || quote.product.addon_id != 2) { 

          if(quote.product.addon_id == 2) bookingFee = true;
          total += parseFloat(quote.product.price) * (quote.product.addon_id == 2 ? 1 : multiplier);
        }
      }
    })
  })

  return total.toFixed(2);
}